import { render, staticRenderFns } from "./sfc-slider.vue?vue&type=template&id=308e9976&"
import script from "./sfc-slider.vue?vue&type=script&lang=js&"
export * from "./sfc-slider.vue?vue&type=script&lang=js&"
import style0 from "./sfc-slider.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports